import { register } from '../component.js';
import 'react';

var _socialIcons_hashnode = register("hashnode", {"color":"#2962FF","path":"M0 0v64h64V0zm15 24c-4.4 4.4-4.4 11.5 0 15.9l9.7 9.7c4.4 4.4 11.5 4.4 15.9 0l9.7-9.7c4.4-4.4 4.4-11.5 0-15.9l-9.7-9.7c-4.4-4.4-11.5-4.4-15.9 0zm22.3 13.5c3.1-3.1 3.1-8.1 0-11.1-3.1-3.1-8.1-3.1-11.1 0-3.1 3.1-3.1 8.1 0 11.1 3.1 3.1 8.1 3.1 11.1 0"});

export { _socialIcons_hashnode as default };
